import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
            <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} Whistlemind Technologies LLP.</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </footer>
        </React.Fragment>
    );
};

export default Footer;